// extracted by mini-css-extract-plugin
module.exports = {"mds-analyst-rating":"mds-analyst-rating","mds-component--on-dark":"mds-component--on-dark","mds-analyst-rating__basic-shield":"mds-analyst-rating__basic-shield"};